"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 14 14",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5.488 4.895a.82.82 0 0 0-1.148 0 .78.78 0 0 0 0 1.116.82.82 0 0 0 1.148 0 .78.78 0 0 0 0-1.116M3.355 3.9a2.22 2.22 0 0 1 3.118 0 2.18 2.18 0 0 1 0 3.106 2.22 2.22 0 0 1-3.118 0 2.18 2.18 0 0 1 0-3.106m6.027 1a.34.34 0 0 0-.482 0l-.495-.495.495.495a.34.34 0 1 0 .482.482l.495.495-.495-.495a.34.34 0 0 0 0-.482M7.91 3.91a1.74 1.74 0 1 1 2.461 2.462A1.74 1.74 0 0 1 7.91 3.91m.476 3.934a.7.7 0 0 1 .7-.7h1.628c.987 0 1.786.8 1.786 1.786a.7.7 0 1 1-1.4 0 .386.386 0 0 0-.386-.386H9.086a.7.7 0 0 1-.7-.7M3.406 9.2a.5.5 0 0 0-.506.494v.347a.7.7 0 1 1-1.4 0v-.347A1.9 1.9 0 0 1 3.406 7.8h3.016a1.9 1.9 0 0 1 1.906 1.894v.347a.7.7 0 1 1-1.4 0v-.347a.5.5 0 0 0-.506-.494z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=UserGroupIcon14.js.map